"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_native_1 = require("react-native");
const emoji = require('emoji-datasource');
const groupBy = require('lodash.groupby');
const orderBy = require('lodash.orderby');
const mapValues = require('lodash.mapvalues');
// Polyfill for Android
require('string.fromcodepoint');
// Conversion of codepoints and surrogate pairs. See more here:
// https://mathiasbynens.be/notes/javascript-unicode
// https://mathiasbynens.be/notes/javascript-escapes#unicode-code-point
// and `String.fromCodePoint` on MDN
function charFromUtf16(utf16) {
    return String.fromCodePoint(...utf16.split('-').map(u => '0x' + u));
}
function charFromEmojiObj(obj) {
    return charFromUtf16(obj.unified);
}
const blocklistedEmojis = ['white_frowning_face', 'keycap_star', 'eject'];
const filteredEmojis = emoji.filter((e) => {
    if (blocklistedEmojis.includes(e.short_name))
        return false;
    if (react_native_1.Platform.OS === 'android') {
        if (e.added_in === '2.0')
            return true;
        if (e.added_in === '4.0')
            return react_native_1.Platform.Version >= 24;
        if (e.added_in === '5.0')
            return react_native_1.Platform.Version >= 26;
        if (e.added_in === '11.0')
            return react_native_1.Platform.Version >= 28;
        else
            return react_native_1.Platform.Version >= 29;
    }
    else {
        return true;
    }
});
// sort emojis by 'sort_order' then group them into categories
const groupedAndSorted = groupBy(orderBy(filteredEmojis, 'sort_order'), 'category');
// convert the emoji object to a character
const emojisByCategory = mapValues(groupedAndSorted, (group) => group.map(charFromEmojiObj));
const CATEGORIES = [
    'Smileys & Emotion',
    'People & Body',
    'Animals & Nature',
    'Food & Drink',
    'Activities',
    'Travel & Places',
    'Objects',
    'Symbols',
];
const DEFAULT_EMOJI_SIZE = 24;
const PADDING = 5;
const styles = react_native_1.StyleSheet.create({
    screen: {
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
    },
    background: {
        backgroundColor: '#00000077',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
    },
    container: {
        backgroundColor: 'white',
        padding: PADDING,
    },
    headerText: {
        padding: PADDING,
        color: 'black',
        justifyContent: 'center',
        textAlignVertical: 'center',
    },
    categoryOuter: {},
    categoryInner: {
        flexWrap: 'wrap',
        flexDirection: 'column',
        marginRight: PADDING * 2,
    },
    clearButton: {
        padding: 15,
        textAlign: 'center',
        color: 'black',
        textAlignVertical: 'center',
    },
});
class ClearButton extends react_1.PureComponent {
    render() {
        var _a;
        return react_1.createElement(react_native_1.TouchableOpacity, { onPress: () => this.props.onEmojiSelected(null) }, react_1.createElement(react_native_1.Text, { style: [styles.clearButton, this.props.clearButtonStyle] }, (_a = this.props.clearButtonText) !== null && _a !== void 0 ? _a : 'Clear'));
    }
}
class EmojiCategory extends react_1.PureComponent {
    render() {
        var _a;
        const emojis = emojisByCategory[this.props.category];
        const size = this.props.emojiSize || DEFAULT_EMOJI_SIZE;
        const style = {
            fontSize: size,
            textAlign: 'center',
            lineHeight: size + PADDING * 2,
            paddingHorizontal: PADDING,
        };
        const rows = (_a = this.props.rows) !== null && _a !== void 0 ? _a : 7;
        const maxHeight = (size + PADDING * 2) * rows + PADDING;
        const categoryText = this.props.localizedCategories
            ? this.props.localizedCategories[CATEGORIES.indexOf(this.props.category)]
            : this.props.category;
        return react_1.createElement(react_native_1.View, { style: styles.categoryOuter }, react_1.createElement(react_native_1.Text, { style: [styles.headerText, this.props.headerStyle] }, categoryText), react_1.createElement(react_native_1.View, { style: [styles.categoryInner, { maxHeight }] }, ...emojis.map((e) => react_1.createElement(react_native_1.Text, {
            style: [style, this.props.emojiStyle],
            key: e,
            onPress: () => this.props.onEmojiSelected(e),
        }, e))));
    }
}
class EmojiPicker extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.renderCategory = ({ item }) => {
            const category = item;
            return react_1.createElement(EmojiCategory, Object.assign(Object.assign({}, this.props), { key: category, category }));
        };
    }
    render() {
        return react_1.createElement(react_native_1.View, { style: [styles.screen, this.props.modalStyle] }, react_1.createElement(react_native_1.View, { style: [styles.container, this.props.containerStyle] }, react_1.createElement(react_native_1.FlatList, {
            data: CATEGORIES,
            horizontal: true,
            style: this.props.scrollStyle,
            initialNumToRender: 1,
            maxToRenderPerBatch: 1,
            keyExtractor: category => category,
            renderItem: this.renderCategory,
        }), this.props.hideClearButton ? null : react_1.createElement(ClearButton, this.props)), react_1.createElement(react_native_1.TouchableWithoutFeedback, {
            onPress: () => {
                var _a, _b;
                (_b = (_a = this.props).onPressOutside) === null || _b === void 0 ? void 0 : _b.call(_a);
            },
        }, react_1.createElement(react_native_1.View, { style: [styles.background, this.props.backgroundStyle] })));
    }
}
exports.default = EmojiPicker;
//# sourceMappingURL=index.js.map